import { applyTallCabinetHeight, getTallCabinetHeightDelta } from './tallCabinetHeightResizer';
import { applyTallCabinetWidthDepth } from './tallCabinetWidthDepthResizer';
import { applyCabinetMaterialUvProjection } from '../modelGeometry/cabinetMaterialUvProjector';
import { isCornerCabinetShape } from '../../../../../../canvas/core/cabinet/cabinetShapes';

export {
  applyTallCabinetHeight,
  applyTallCabinetWidthDepth,
  getTallCabinetHeightDelta,
};

// Reprojects the shared cabinet finish after every geometry/layout resize so
// all wood surfaces use one object-space scale instead of stretched GLB UVs.
export function applyTallCabinetMaterialUvProjection(instance, shape) {
  // Dominant-axis box projection is intended for straight cabinets. Angled
  // corner fronts retain their authored UVs to avoid diagonal scale changes.
  if (isCornerCabinetShape(shape)) {
    return;
  }

  applyCabinetMaterialUvProjection(instance, shape, {
    meshNamePattern: /.*/,
    useDominantTexture: true,
  });
}

export function applyTallCabinetGeometry(instance, shape) {
  if (!instance || !shape) {
    return;
  }

  applyTallCabinetHeight(instance, shape);
  applyTallCabinetWidthDepth(instance, shape);
  applyTallCabinetMaterialUvProjection(instance, shape);
}
